import css from 'styled-jsx/css';

const styles = css.global`.contente-dropdown {
  position: relative;
  width: 100%;
}

.contente-dropdown * {
  color: #000;
}

.dropdown {
  position: relative;
  padding: 10px 12px;
  border: 1px solid #727272;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}

.dropdown-arrow {
  width: 20px;
  height: 20px;
}

.dropdown-results-content {
  position: absolute;
  top: 70%;
  left: -22px;
  right: 0;
  border: 1px solid #727272;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  z-index: 1000;
  margin: 16px;
}

.dropdown-label {
  color: #666;
  display: none;
  position: absolute;
  z-index: 99;
  left: 25px;
  top: -12px;
  background-color: #fff;
  padding: 0 5px;
  font-size: 14px;
  font-family: 'SantanderText', 'Open Sans', 'Helvetica', 'Arial', sans-serif;
}

.dropdown-results {
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-results:hover {
  background-color: #deedf2;
}

.result {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #cc0000;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.result-selected {
  background-color: #cc0000;
  border-color: #cc0000;
}

.result-selected span {
  color: #fff !important;
}

.result-selected img {
  width: 20px;
}`;

export default styles;